<template>
  <v-card elevation="0" class="pa-0 ma-0 card mb-2" color="#fff">
    <v-card-title primary-title class="justify-xs-center pa-3">
      <v-flex sm12 class="pa-0 ma-0">
        <div class="title text-xs-center pb-1">
          Plano {{ plan_name.replace("(Recomendado)", "") }} ({{ discount }}%)
        </div>
        <div class="annualDiscount py-3">
          <div class="text-xs-center pa-0">Economize por ano até</div>
          <div class="text-xs-center pa-0 ma-0 annualValue">
            <span class="economyCurrency pt-0">R$ </span>
            <span class="economyValue text-center font-weight-bold">{{
              (economy_year * 1) | formatCurrencyInteger
            }}</span>
            <span class="economyCurrency pa-0">
              ,{{ economy_year | formatCurrencyDecimal }}</span
            >
          </div>
        </div>
        <p class="mt-2 text-xs-center font-weight-bold">
          R$ {{ economy_mounth | formatCurrency }} por mês
        </p>
      </v-flex>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  props: {
    plan_name: {
      type: String,
      required: false,
    },
    discount: {
      type: Number,
      required: false,
    },
    economy_mounth: {
      type: Number,
      required: false,
    },
    economy_year: {
      type: Number,
      required: false,
    },
    recommended: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.economyValue {
  font-size: 50px;
  font-weight: bolder;
}
.economyDecimal {
  font-size: 30px;
  font-weight: 600;
}
.economyCurrency {
  font-size: 18px;
  font-weight: 600;
}
.annualDiscount {
  background: #8748f3 !important;
  color: #fff !important;
  border-radius: 20px;
}
.card {
  border: 2px solid #8748f3 !important;
  border-radius: 20px;
}
.annualValue {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Poppins" !important;
  line-height: 3.5rem !important;
}
</style>
